import Link from 'next/link'
import { MenuLink } from '@reach/menu-button'
import Stack from '@careguide/stack'
import Button from 'components/generic/Button'
import { HeaderLink } from '../HeaderLink'

export const NavMobileLoggedOut = ({ links, getStartedCta }: TODO) => (
  <>
    <Stack gap='4' align='center'>
      {links.map((item: TODO, index: number) =>
        item.isNextLink ? (
          <MenuLink as={InternalLink} key={index} href={item.link}>
            {item.title}
          </MenuLink>
        ) : (
          <MenuLink key={index} as={HeaderLink} href={item.link}>
            {item.title}
          </MenuLink>
        )
      )}
    </Stack>

    <Stack gap='4'>
      <MenuLink as={Button} style={{ display: 'block' }} href='/log-in' variant='secondary' fluid>
        Log in
      </MenuLink>
      <MenuLink
        as={Button}
        style={{ display: 'block' }}
        href={getStartedCta.link}
        rel='nofollow'
        fluid
      >
        {getStartedCta.text}
      </MenuLink>
    </Stack>
  </>
)

const InternalLink = ({ href, ...props }: TODO) => (
  <Link href={href} passHref>
    <HeaderLink {...props} />
  </Link>
)
